export default "__VITE_ASSET__BBZw60KN__"